//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: {
        is_login: {
            type: Boolean
        },
        user: {
            type: Object
        },
        care_msg: {
            type: String
        },
        care_type: {
            type: String
        }
    },
    computed: {
        class_white() {
            return this.care_type === 'night' ? 'white' : ''
        }
    },
    methods: {
    }
}
